import { gql } from "lib/apolloClient";

export const courseItemFragment = gql`
  fragment courseItem on LearningCourse {
    id
    title
    state
    isBookmarked
    displayMetadata
    type
    academicCourse {
      id
      code
    }
  }
`;

export const learningCourseDetailsFragment = gql`
  fragment learningCourse on LearningCourse {
    id
    subjects {
      id
      name
      grades {
        id
        name
      }
      subjectGroup {
        id
        name
      }
      isArchived
      recommendedPhase {
        gradeId
        phaseId
      }
    }
    grades {
      id
      name
      subjects {
        id
        name
        isArchived
        subjectGroup {
          id
          name
        }
      }
      yearGroup {
        id
        name
        examSession {
          id
          year
        }
      }
      displaySequence
      globalGrade {
        id
        uid
        name
        constants
      }
    }
  }
`;

export const subjectFragment = gql`
  fragment subjectItem on Subject {
    id
    subjectName: name
    isArchived
    type
  }
`;
